import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const WhatsAppIcon = (props) => {
  const {fill = '#fff'} = props;
    return (
        <SvgIcon {...props} style={{ fill }} viewBox="0 0 17.915 18">
          <path className="a"
                d="M.057,18l1.265-4.622a8.919,8.919,0,1,1,3.463,3.382L.057,18ZM5,15.145a7.4,7.4,0,1,0-2.057-2L2.2,15.88,5,15.145Zm8.54-4.1c-.056-.093-.2-.149-.428-.26s-1.319-.651-1.523-.725-.352-.112-.5.112-.576.725-.706.874-.26.167-.483.056A6.083,6.083,0,0,1,8.111,10a6.709,6.709,0,0,1-1.24-1.544c-.13-.223-.013-.344.1-.454s.223-.26.334-.391a1.462,1.462,0,0,0,.225-.371.41.41,0,0,0-.019-.391c-.056-.111-.5-1.208-.687-1.655s-.365-.376-.5-.383L5.894,4.8a.817.817,0,0,0-.594.279,2.5,2.5,0,0,0-.78,1.859,4.337,4.337,0,0,0,.91,2.305,9.937,9.937,0,0,0,3.807,3.365,12.9,12.9,0,0,0,1.27.469,3.063,3.063,0,0,0,1.4.089,2.3,2.3,0,0,0,1.5-1.06,1.857,1.857,0,0,0,.13-1.061Z"
                transform="translate(-0.057)"/>
        </SvgIcon>
    );
};

export default WhatsAppIcon;
